import { CairoEntityPageState } from '../state';
import { createContext, useContext } from 'react';
import { assertContextValue } from '../createContext';

const context = createContext<CairoEntityPageState | null>(null);

export const cairoEntityPageContext = context;
export const CairoEntityPageContextProvider = context.Provider;
export const CairoEntityPageContextConsumer = context.Consumer;

export const useCairoEntityPageContext = () => {
  const value = useContext(cairoEntityPageContext);
  assertContextValue('CairoEntityPageProvider', value);
  return value as CairoEntityPageState;
};

// This is here to allow to optionally check for cairo entity page context before completely deprecating it and making fqdn mandatory on existing widgets
export const useCairoEntityPageContextCompat = () =>
  useContext(cairoEntityPageContext);
